import defaultErrorHandler from "actions/global/default-error-handler";
import settings from "utils/settings";

import { requestCommonFilters, requestCommonSearch } from "../../common/requests";
import {
  BATTERY_HISTORY_ERROR,
  BATTERY_HISTORY_LOADING,

  BATTERY_HISTORY_FILTERS,
  BATTERY_HISTORY_LIST
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/battery/history";

export const setLoading = (status) => ({
  type: BATTERY_HISTORY_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, scooterUrl)
    .then((response) => {
      dispatch({
        type: BATTERY_HISTORY_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BATTERY_HISTORY_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, scooterUrl)
    .then((response) => {
      dispatch({
        type: BATTERY_HISTORY_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, BATTERY_HISTORY_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/battery-history/actions.js